var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _vm._v(
        "\n    " +
          _vm._s(_vm.row.startTrainStation && _vm.row.startTrainStation.name) +
          "\n    "
      ),
      _vm.row.startTrainStation && _vm.row.endTrainStation
        ? [_vm._v("-")]
        : _vm._e(),
      _vm._v(
        "\n    " +
          _vm._s(_vm.row.endTrainStation && _vm.row.endTrainStation.name) +
          "\n"
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }